import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca61364c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "dropdown-list"
}
const _hoisted_3 = ["onClick"]

import { ref, watch } from 'vue'
  import { useRoute } from 'vue-router'

  import { IDropdownOption, TDropdownOptions } from '@/types/forms'
  interface Props {
    options: TDropdownOptions
    selected: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    selected: null
  },
  emits: {
    selected: (option: IDropdownOption) => option,
  },
  setup(__props: any, { emit }) {

const props = __props as {
    options: TDropdownOptions
    selected: string
  }

  

  

  const route = useRoute()
  let isOpen = ref(false)
  let dropdownOptions = props.options.map((option) => option)

  function toggleDropdown() {
    isOpen.value = !isOpen.value
  }
  function updateSelected(option: IDropdownOption) {
    emit('selected', option)
    isOpen.value = false
  }

  watch(
    () => route.path,
    () => (isOpen.value = false)
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dropdown-selected",
      onClick: toggleDropdown
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_unref(isOpen))
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropdownOptions), (option, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["dropdown-item", { selected: option.value === __props.selected }]),
              key: index,
              onClick: ($event: any) => (updateSelected(option))
            }, _toDisplayString(option.label), 11, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})